export function checkoutLineItemImages<T extends { video?: boolean }>({
  images,
}: {
  images?: T[] | null;
}): T[] {
  return (images ?? []).filter((image) => image.video !== true);
}
